import { setCookie, getCookie } from '../functions';

const ALLCOOKIESVALUE = 'allcookies';
const NOCOOKIESVALUE = 'nocookies';

document.addEventListener('DOMContentLoaded', async () => {
    if (typeof window.dataLayer === 'undefined') window.dataLayer = [];

    let cookieConsentEl = document.getElementById('cookie-consent');
    let cookieToggleEl = document.getElementById('cookie-toggle');

    let cookieAcceptButton = document.getElementById('cookie-accept');
    let cookieDenyButton = document.getElementById('cookie-deny');
    let cookieAcceptAllButton = document.getElementById('cookie-accept-all');

    let cookieCheckboxes = document.getElementsByClassName('cookie-group');
    if (!cookieConsentEl || cookieCheckboxes.length === 0) {
        if (cookieToggleEl) {
            cookieToggleEl.classList.toggle('is-hidden');
        }
        return;
    }

    let cookieConsent = await getCookie('occ');

    if (cookieConsent) {
        if (cookieConsent === ALLCOOKIESVALUE) {
            for (let i = 0; i < cookieCheckboxes.length; i++) {
                cookieCheckboxes[i].checked = true;
            }
        }
        if (cookieConsent !== (ALLCOOKIESVALUE || NOCOOKIESVALUE)) {
            for (let i = 0; i < cookieCheckboxes.length; i++) {
                if (cookieConsent.indexOf(cookieCheckboxes[i].value) !== -1) {
                    cookieCheckboxes[i].checked = true;
                }
            }
        }
    }
    else {
        toggleCookieConsentEl();
    }

    if (cookieDenyButton) {
        cookieDenyButton.addEventListener('click', () => {
            setCookie('occ', NOCOOKIESVALUE, 365);
            toggleCookieConsentEl();
            location.reload();
            return false;
        });

    }

    if (cookieAcceptButton) {
        cookieAcceptButton.addEventListener('click', () => {
            let cookieValueString = '';
            let cookievalueArray = [];

            for (let i = 0; i < cookieCheckboxes.length; i++) {
                if (cookieCheckboxes[i].checked) {
                    cookievalueArray.push(cookieCheckboxes[i].value);
                }
            }

            if (cookievalueArray.length === cookieCheckboxes.length) cookieValueString = ALLCOOKIESVALUE
            if (cookievalueArray.length === 0) cookieValueString = NOCOOKIESVALUE

            let cookieValue = cookieValueString ? cookieValueString : cookievalueArray

            setCookie('occ', cookieValue, 365);
            toggleCookieConsentEl();
        });
    }

    if (cookieAcceptAllButton) {
        cookieAcceptAllButton.addEventListener('click', () => {
            for (let i = 0; i < cookieCheckboxes.length; i++) {
                cookieCheckboxes[i].checked = true;
            }
            setCookie('occ', ALLCOOKIESVALUE, 365);
            toggleCookieConsentEl();
        });
    }

    if (cookieToggleEl) {
        cookieToggleEl.addEventListener('click', () => {
            toggleCookieConsentEl();
        });
    }

    function toggleCookieConsentEl() {
        cookieConsentEl.classList.toggle('is-hidden');

        if (toggleCookieConsentEl) {
            cookieToggleEl.classList.toggle('is-hidden');
        }
    }
});
